export const List = () => import("./List.vue");
export const Create = () => import("./Create.vue");
export const Edit = () => import("./Edit.vue");
export const CreateOfficer = () => import("./CreateOfficer.vue");
export const LedgerBarcode = () => import("./Barcode.vue");
export const GuestBarcode = () => import("./GuestBarcode.vue");
